// Browser polyfills required before any @ton/* module loads.
// @ton/core (BitString/BitBuilder) references the Node `Buffer` global, which
// does not exist in browsers. This module installs it on the global scope and
// must be imported before @ton/core is evaluated (see main.tsx import order).
import { Buffer } from 'buffer';

const globalScope = globalThis as typeof globalThis & {
  Buffer?: typeof Buffer;
  global?: typeof globalThis;
};

if (!globalScope.Buffer) {
  globalScope.Buffer = Buffer;
}
if (!globalScope.global) {
  globalScope.global = globalScope;
}
